import { BaseRequestModel } from "./BaseModel/BaseRequestModel";
import { PaginationModel } from "./pagination-model";

export class payRequestModel extends BaseRequestModel{
    Type:string;
    EvalType?:number;
    ID:number=0;
    City?:string;
    TenderNumber?:string;
    TenderKeyword?:string;
    BlacklistedKeyword?:string;
    PPRANumber?:string;
    TenderWorth?:string;
    Sector?:string;
    Organization?:string;
    TypeID?:string;
    Date:Date;
    pagination:PaginationModel;

}
